<template>
    <div>
        <h2>Application Questions</h2>

        <b-row v-for="question in value" :key="question.id" class="mb-2">
            <b-col cols="auto">{{question.response === 'Y' ? 'Yes' : 'No'}}</b-col>
            <b-col cols="11">{{question.questionText}}</b-col>

            <template v-if="question.additionalResponse">
                <b-col cols="1"></b-col>
                <b-col cols="11"><i>{{question.additionalResponse}}</i></b-col>
            </template>

            <template v-if="question.changeDate">
                <b-col cols="1"></b-col>
                <b-col cols="11">Date Changed: {{question.changeDate}}</b-col>
            </template>

        </b-row>

    </div>
</template>

<script>  
export default {
    props: {
        value: Array,
    },
}
</script>

<style>
</style>
